export default () => ({
  init() {
    setTimeout(() => {
      this.$el.remove();
    }, 5000);
  },
})
